import { useQueryStates } from 'nuqs';
import * as React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../components/Breadcrumb';
import { ContactsSelfImport } from '../../components/contacts/ContactsSelfImport';
import { MultiContainerHeader } from '../../components/MultiContainerHeader';
import { policyImportSearchParams } from '../../constants/policyImportSearchParams';

export function PolicyContactsImportFromCSVPage() {
	const history = useHistory();
	const [{ dataRefresh }, setSearchParams] = useQueryStates(policyImportSearchParams);
	const [initialDataRefresh] = React.useState(dataRefresh);

	// The data refresh clears renewal keyfacts and policy tags, so the param is dropped once read:
	// left in the URL, a reload would re-check the option after the user had unchecked it.
	React.useEffect(() => {
		if (dataRefresh) {
			setSearchParams({ dataRefresh: null });
		}
	}, [dataRefresh, setSearchParams]);

	const onProcessingRequestClose = () => {
		history.push(`/dataBoards/policies`);
	};
	return (
		<>
			<MultiContainerHeader
				appBarHeader={
					<Breadcrumb>
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<NavLink to='/dataBoards'>Data Boards</NavLink>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
							<BreadcrumbItem>
								<BreadcrumbLink asChild>
									<NavLink to='/dataBoards/policies'>Policies</NavLink>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
							<BreadcrumbPage>CSV Import</BreadcrumbPage>
						</BreadcrumbList>
					</Breadcrumb>
				}
			/>

			<ContactsSelfImport
				onRequestClose={onProcessingRequestClose}
				completedBtnText='Back to policies'
				initialDataRefresh={initialDataRefresh}
			/>
		</>
	);
}
